import { overlay } from "../Store/OverlayStore"

const showOverlay = e => {
	const contextId = e.target.dataset.guardContext

	if ( contextId ) {
		e.preventDefault()
		overlay.show( contextId )
	} else {
		console.error( "missing [data-guard-context] attribute for ", e.target )
	}
}

const listen = links =>
	links.forEach( node => node.addEventListener( 'click', showOverlay ) )

export const OverlayTriggerService = {
	listen,
}
